export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3768131.6a2622fa.jpg";